/**
 *@俄语
 *@params
 *@author WangPing
 *@date 2020-07-20
 */

export default {
  _not_interested_in_this_video: 'Не заинтересованы в этом видео? %second%',
  _switch_one: 'еще один',
  _next_reward_text: 'Посмотрите другое видео, чтобы получить',
  _next_reward_button: 'Смотри',
}